import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import FileUploadBox from "../components/FileUploadBox";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAcFormate,
  uploadAcFormate,
} from "../../store/reducers/acFormateSlice";
import { toast } from "react-toastify";

const ACFormate = () => {
  const [a6File, setA6File] = useState(null);
  const [a7File, setA7File] = useState(null);

  const [errors, setErrors] = useState({
    a6: "",
    a7: "",
  });

  const dispatch = useDispatch();

  const { acFormateList, loading } = useSelector(
    (state) => state.acFormate
  );

  useEffect(() => {
    dispatch(fetchAcFormate());
  }, [dispatch]);

  useEffect(() => {
    if (acFormateList?.length) {
      const a6 = acFormateList.find((i) => i.type === "a6_format");
      const a7 = acFormateList.find((i) => i.type === "a7_format");
  
      if (a6?.file_url) {
        setA6File(a6.file_url);
      }
  
      if (a7?.file_url) {
        setA7File(a7.file_url);
      }
    }
  }, [acFormateList]);

  // 👉 Get file names from API
  const getFileName = (type) => {
    const file = acFormateList?.find((item) => item.type === type);
    return file?.file_url?.split("/").pop();
  };

  const handleUpload = async () => {
    const formData = new FormData();
    const appendFormatField = (key, value) => {
      if (!value) {
        formData.append(key, "none");
        return;
      }

      formData.append(key, value);
    };

    setErrors({ a6: "", a7: "" });

    appendFormatField("a6_format", a6File);
    appendFormatField("a7_format", a7File);
  
    try {
      const res = await dispatch(uploadAcFormate(formData));
  
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Data Updated Successfully");
        dispatch(fetchAcFormate());
      }
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  return (
    <div className="container-fluid mt-2">
      <div className="row">
        {/* A6 Section */}
        <div className="col-12 col-md-6 mb-4">
          <Paper
            elevation={3}
            sx={{ p: 3, height: "100%", borderRadius: "12px" }}
          >
            <Typography variant="h6" fontWeight={600} gutterBottom>
              A6 Format
            </Typography>

            <Typography variant="body2" color="text.secondary" mb={2}>
              Upload “cut contour” file (A6)
              <br />
              <strong>Size:</strong> 105 × 148 mm
            </Typography>

            {/* Existing File */}
            {getFileName("a6_format") && (
              <Typography variant="body2" mb={1}>
                Existing File: <strong>{getFileName("a6_format")}</strong>
              </Typography>
            )}

            <Box sx={{ width: "100%" }}>
              <FileUploadBox
                label="Upload A6 Cut Contour PDF"
                file={a6File}
                setFile={(file) => {
                  setA6File(file);
                  setErrors((prev) => ({ ...prev, a6: "" }));
                }}
                inputId="a6FileInput"
              />
            </Box>

            {/* Error */}
            {errors.a6 && (
              <Typography color="error" variant="caption">
                {errors.a6}
              </Typography>
            )}
          </Paper>
        </div>

        {/* A7 Section */}
        <div className="col-12 col-md-6 mb-4">
          <Paper
            elevation={3}
            sx={{ p: 3, height: "100%", borderRadius: "12px" }}
          >
            <Typography variant="h6" fontWeight={600} gutterBottom>
              A7 Format
            </Typography>

            <Typography variant="body2" color="text.secondary" mb={2}>
              Upload “cut contour” file (A7)
              <br />
              <strong>Size:</strong> 74 × 105 mm
            </Typography>

            {/* Existing File */}
            {getFileName("a7_format") && (
              <Typography variant="body2" mb={1}>
                Existing File: <strong>{getFileName("a7_format")}</strong>
              </Typography>
            )}

            <Box sx={{ width: "100%" }}>
              <FileUploadBox
                label="Upload A7 Cut Contour PDF"
                file={a7File}
                setFile={(file) => {
                  setA7File(file);
                  setErrors((prev) => ({ ...prev, a7: "" }));
                }}
                inputId="a7FileInput"
              />
            </Box>

            {/* Error */}
            {errors.a7 && (
              <Typography color="error" variant="caption">
                {errors.a7}
              </Typography>
            )}
          </Paper>
        </div>
      </div>

      {/* Upload Button */}
      <div className="row">
        <div className="col-12 d-flex justify-content-start">
          <Button
            variant="contained"
            onClick={handleUpload}
            disabled={loading}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              px: 4,
              background: "#f6615f",
              "&:hover": {
                background: "#f6615f",
              },
            }}
          >
            {loading ? "Uploading..." : "Upload Files"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ACFormate;
